import { createSelector } from "@reduxjs/toolkit"

export const previewInterviewSelector = (condition) => 
    createSelector(
        state => condition ? state.preview : state.interview,
        substate => substate
    )
